import './home-product.scss';
import compareService from 'common/util/compareService';
import favoriteService from 'common/util/favoriteService';
import cartSerivce from 'common/util/cartSerivce';

$('.home-product').each(function () {
	let $home_product = $(this);

	function getProductData() {
		return {
			id: +$home_product.data('id'),
			name: $home_product.data('name'),
			image: $home_product.data('image')
		}
	}

	$home_product.find('.home-product__compare-btn').on('click', function () {
		if ($home_product.hasClass('home-product_in-compare')) {
			compareService.remove(getProductData());
		} else {
			compareService.add(getProductData());
		}
	});

	$home_product.find('.home-product__favorite-btn').on('click', function () {
		if ($home_product.hasClass('home-product_in-favorite')) {
			favoriteService.remove(getProductData());
		} else {
			favoriteService.add(getProductData());
		}
	});

	$home_product.find('.home-product__cart-btn').on('click', function () {
		cartSerivce.add(+$home_product.data('sku-id'))
	});
});

compareService.addListenerAdd(product => {
	$('.home-product').each(function () {
		let $home_product = $(this);

		if (product.id !== +$home_product.data('id')) {
			return;
		}

		$home_product.addClass('home-product_in-compare');
	});
});

compareService.addListenerRemove(product => {
	$('.home-product').each(function () {
		let $home_product = $(this);

		if (product.id !== +$home_product.data('id')) {
			return;
		}

		$home_product.removeClass('home-product_in-compare');
	});
});

favoriteService.addListenerAdd(product => {
	$('.home-product').each(function () {
		let $home_product = $(this);

		if (product.id !== +$home_product.data('id')) {
			return;
		}

		$home_product.addClass('home-product_in-favorite');
	});
});

favoriteService.addListenerRemove(product => {
	$('.home-product').each(function () {
		let $home_product = $(this);

		if (product.id !== +$home_product.data('id')) {
			return;
		}

		$home_product.removeClass('home-product_in-favorite');
	});
});

cartSerivce.addListenerAddSku((skuId, resp) => {
	$('.home-product').each(function () {
		let $home_product = $(this);

		if (skuId !== +$home_product.data('sku-id')) {
			return;
		}

		let $btn = $(document.querySelector('#to-cart-btn').content.cloneNode(true));
		$home_product.find('.home-product__cart-btn').replace($btn);
	});
});
